var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar m-b-28"},[_c('div',{staticClass:"bar",style:(`width: ${this.percent}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }